export default {

	edipart: {
		id: null,
		name: null,
		ediPart: null,
		ediPartIdTms: null,
		inboundSetups:
					[
						{
							id: null,
							ssl:null,
							sender: null,
							endpoint: null,
							edipartId:null,
							recipient: null,
							createDate: null,
							description:null,
							messagetype:null,
							allowUpdates:null,
							messageFormat:null,
							testMode: false,
							endpointPath: '',
							senderQualifier: null,
							transportMethod:null,
							endpointPassword: null,
							endpointUsername: null,
							recipientQualifier: null,
							messageTypeDescription: null,
							messageFormatDescription: null,
							transportMethodDescription: null,
						}
					],
		outboundSetups:
					[
						{
							id:null,
							ssl:null,
							endpoint: null,
							edipartid:null,
							keepAlive:null,
							createDate: null,
							messagetype:null,
							messageFormat:null,
							tempfilePrefix: null,
							transportMethod:null,
							endpointPassword: null,
							endpointUsername: null,
							isTempfileEnabled:null,
							messageTypeDescription: null,
							assosiationAssignedCode:null,
							messageFormatDescription: null,
							transportMethodDescription: null,
						}
					]
	},
};
